<script>
import Utils from '@/helpers/Utils'

export default {
  name: 'CopyWithTooltip',
  props: {
    contentToCopy: {
      type: String,
      default: ''
    },
    tooltipMessage: {
      type: String,
      default: 'copied to clipboard!'
    },
    buttonText: {
      type: String,
      default: 'Copy Content'
    },
    overlayDuration: {
      type: Number,
      default: 200
    },
    tooltipDuration: {
      type: Number,
      default: 2000
    },
    overlayEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showTooltip: false,
      showOverlay: false
    }
  },
  methods: {
    showAndHideTooltip() {
      this.showTooltip = true
      setTimeout(() => {
        this.showTooltip = false
      }, this.tooltipDuration)
    },
    handleOverlayDisplay() {
      this.showOverlay = this.overlayEnabled
      if (!this.showOverlay) {
        this.showAndHideTooltip();
        return
      }
      setTimeout(() => {
        this.showOverlay = false
        this.showAndHideTooltip();
      }, this.overlayDuration)
    },
    copyContentAndHandleDisplay() {
      Utils.copyToClipboard(this.contentToCopy, false)
      this.handleOverlayDisplay()
    }
  }
}
</script>

<template>
  <div>
    <b-tooltip
      triggers="click"
      custom-class="copy-tooltip"
      :target="`copy-button-${_uid}`"
      :show.sync="showTooltip"
    >
      {{ tooltipMessage }}
    </b-tooltip>

    <!-- Overlay and Slot for Field -->
    <b-overlay :show="showOverlay" rounded="sm" opacity="0.6">
      <!-- Copy Button -->
      <div class="copy-btn-wrapper">
        <button
          :id="`copy-button-${_uid}`"
          v-if="Boolean(contentToCopy)"
          class="button copy-floating-btn"
          @click.prevent="copyContentAndHandleDisplay"
        >
          <font-awesome-icon icon="copy" class="i" />
          {{ buttonText }}
        </button>
        <slot></slot>
      </div>
    </b-overlay>
  </div>
</template>

<style scoped lang="scss">
.copy-btn-wrapper {
  position: relative;
}

.copy-floating-btn {
  position: absolute;
  width: auto;
  top: 15px;
  right: 20px;
  border-radius: 4px;
}

.copy-tooltip {
  background: #434343b0;
  top: -5px !important;
}
</style>
